import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import Typography from '@material-ui/core/Typography';
import FormLabel from '@material-ui/core/FormLabel';
import FormGroup from '@material-ui/core/FormGroup';
import Checkbox from '@material-ui/core/Checkbox';
import InsertDriveFileOutlinedIcon from '@material-ui/icons/InsertDriveFileOutlined';
import Markdown from 'react-markdown';
import { Loading } from 'react-admin';
import { useForm } from 'react-hook-form';
import LegalAgreement from './agreement.md';

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: '100%',
    background: '#eee',
    marginTop: theme.spacing(3),
  },
  paper: {
    background: '#fff',
    height: 400,
    padding: theme.spacing(2),
    overflowY: 'scroll',
  },
  submit: {
    margin: 'auto',
    marginTop: theme.spacing(2),
  },
  actions: {
    display: 'block',
    padding: theme.spacing(3),
  },
  label: {
    cursor: 'pointer',
    fontSize: 14,
  },
  icon: {
    marginRight: theme.spacing(1),
    width: 20,
  },
  link: {
    textDecoration: 'none',
  },
}));

export default ({ onSubmit }) => {
  const classes = useStyles();
  const { register, handleSubmit, errors } = useForm();
  const [text, setText] = useState('');

  useEffect(() => {
    const loadText = async () => {
      try {
        const response = await fetch(LegalAgreement);
        const text = await response.text();
        setText(text);
      } catch (e) {
        console.log('ERROR FETCH', e);
      }
    };
    loadText();
  }, []);

  if (!text) {
    return <Loading />;
  }

  return (
    <form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
      <Card className={classes.root}>
        <CardContent>
          <Typography variant="caption" display="block" gutterBottom>
            This is a legal agreement between you and viBBes.
          </Typography>
          <Box display="flex" mb={2} alignItems="center">
            <InsertDriveFileOutlinedIcon className={classes.icon} />
            <a className={classes.link} href="/viBBes_Legal_Agreement.pdf" target="_blank" download>
              Download PDF
            </a>
          </Box>
          <Paper className={classes.paper} variant="outlined">
            <Markdown escapeHtml={false}>{text}</Markdown>
          </Paper>
        </CardContent>
        <div className={classes.actions}>
          <Grid item xs={12}>
            <FormControl error={errors.hasOwnProperty('legal_agreement')}>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox id="legal_agreement" color="primary" />}
                  name="legal_agreement"
                  label={
                    <FormLabel htmlFor="legal_agreement" className={classes.label}>
                      By checking this box I confirm that I have read and agree to be bound by the
                      Agreement above
                    </FormLabel>
                  }
                  inputRef={register({ required: 'required' })}
                />
              </FormGroup>
            </FormControl>
          </Grid>
          <Grid item xs={12} style={{ textAlign: 'center' }}>
            <Button type="submit" variant="contained" color="primary" className={classes.submit}>
              Sign Up
            </Button>
          </Grid>
        </div>
      </Card>
    </form>
  );
};
